module.exports = __webpack_public_path__ + "static/media/shapes_16.bf7cbbbb.svg";